import { API } from '../../../config'

export const addUniform = (value, successCB, failedCB) => async dispatch => {
  API.POST('/profile/uniform', value).then((response) => {
    return successCB && successCB(response)
  })
  .catch((err) => {
    return failedCB && failedCB(err.error || err.message)
  })
}